import React, { useEffect, useState, ChangeEvent } from 'react'
import Modal from 'react-bootstrap/Modal'
import { Button, Checkbox, TextField} from '@mui/material';
import { CreateUrl, CallGetAPI, CallPutAPI, CallPostAPI } from 'Utils/ApiHelper.js';
import { DataGrid, Column, Export, GroupPanel, Grouping, FilterRow, Pager, Paging, StateStoring, HeaderFilter, Selection, Sorting } from 'devextreme-react/data-grid';
import { AlarmData, Contact } from '../Alarm Functions/AlarmOverviewFunctions'
import Loader from '../../Utils/Loader/NewLoader2025'
import moment from 'moment';
import { NotificationContainer, NotificationManager } from 'react-notifications';
import { FormattedMessage, IntlShape, useIntl } from 'react-intl';
import deMessages from "devextreme/localization/messages/de.json";
import frMessages from "devextreme/localization/messages/fr.json";
import esMessages from "devextreme/localization/messages/es.json";
import ptMessages from "devextreme/localization/messages/pt.json";
import { locale, loadMessages } from "devextreme/localization";

interface Props {
    show: boolean
    handleGroupModalClick: () => void
    tempAlarm: AlarmData
    contactsForCompany: Contact[]
    handleAddContactsToAlarm: (email: string) => void
    close: () => void
    handleSwitchToAlarmContacts: (alarmId: number | null) => void
}


interface Group {
    companyId: number
    createdBy: string
    name: string
    uiContacts: string[]
}


const RecipientsModal: React.FC<Props> = ({
    show,
    handleGroupModalClick,
    tempAlarm,
    contactsForCompany,
    handleAddContactsToAlarm,
    close,
    handleSwitchToAlarmContacts
}) => {


    ///group stylings
    const iconStyle = {
        fontSize: '22px'
    }

    const overViewStyle = {
        backgroundColor: "#f7f7f7",
        borderRadius: "5px",
        padding: "10px 0 0 0",
        width: "90%",
        boxShadow: "2px 2px 10px #00000060",
    }


    ///hooks
    const intl:IntlShape = useIntl()
    locale(sessionStorage.getItem('language') ? sessionStorage.getItem('language') : 'en-GB');
    loadMessages(frMessages);
    loadMessages(deMessages);
    loadMessages(esMessages);
    loadMessages(ptMessages);

    //state
    const [loading, setLoading] = useState<boolean>(true)
    const [addGroup, setAddGroup] = useState<boolean>(false)
    const [tempGroup, setTempGroup] = useState<Group | undefined>()
    const [noContacts, setNoContacts] = useState<boolean>(false)

    useEffect(() => {
        if (contactsForCompany.length > 0 && tempAlarm) {
            setLoading(false)
            setNoContacts(false)
        } else if (contactsForCompany.length === 0 && tempAlarm) {
            setLoading(false)
            setNoContacts(true)
        } 
    }, [contactsForCompany, tempAlarm])

    const createSuccessNotification = (): void => {
        NotificationManager.success(intl.formatMessage({ id: 'Saved Changes' }), intl.formatMessage({ id: 'Success' }));
    };

    const createErrorNotification = (): void => {
        NotificationManager.error(intl.formatMessage({ id: 'Error Saving Changes' }), intl.formatMessage({ id: 'Check console for details' }), 5000, () => {
            alert('error');
        });
    };

    const renderNotifications = (data):React.ReactNode => {
        return (
            <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                <p>{data.data.email}</p>
                <div style={{ display: 'flex', justifyContent: 'space-evenly', width: 100 }}>
                    <i
                        className="fa-solid fa-envelope"
                        style={{ ...iconStyle, color: data.data.enabledEmail ? 'green' : 'gray' }}></i>
                    {/*!window.location.hostname.includes('zonelog.net') && <i
                        className="fas fa-sms"
                        style={{ ...iconStyle, color: data.data.enabledSMS ? 'green' : 'gray' }}></i>*/}
                    {!window.location.hostname.includes('zonelog.net') && <i
                        className="fa-brands fa-square-whatsapp"
                        style={{ ...iconStyle, color: data.data.enabledWhatsApp ? 'green' : 'gray' }}></i>}
                </div>
            </div>
        )
    }

    const renderCheckBox = (data): React.ReactNode => {
        const isSelected = tempAlarm.contacts.includes(data.data.email)
        return (
            <div style={{display: 'flex', justifyContent: 'center', marginTop: -10} }>
                <Checkbox checked={isSelected} onChange={(): void => handleAddContactsToAlarm(data.data.email)} />
            </div>
        )
    }

    const handleAddGroupClick = ():void => {
        if (!addGroup && sessionStorage.getItem('companyId') !== null && sessionStorage.getItem('userId') !== null) {
            setTempGroup({
                companyId: parseInt(sessionStorage.getItem('companyId')),
                createdBy: sessionStorage.getItem('userName'),
                name: "",
                uiContacts: tempAlarm.contacts
            })
        } else {
            setTempGroup(undefined)
        }
        setAddGroup(!addGroup)
    }


    const saveRecipients = () => {
        
        
        if (addGroup) {
            //save group
            const contactIds: number[] = []
            contactsForCompany.forEach(con => {

                if (tempGroup.uiContacts.includes(con.email)) {
                    contactIds.push(con.id)
                }
            })

            const requestOptions = {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                    companyId: tempGroup?.companyId,
                    createdBy: sessionStorage.getItem('userName'),
                    name: tempGroup?.name,
                    uiContactIds: contactIds,
                })
            }

            CallPostAPI(CreateUrl(`/api/Contacts/AddContactGroup`), requestOptions)
                .then(data => {
                    console.log(data)
                    setTempGroup(undefined)
                    setAddGroup(false)
                    
                })
                .catch(err => {
                    console.error(err)
                })

        }


        const contactIdsAlarm: number[] = []
        contactsForCompany.forEach(con => {
            if (tempAlarm.contacts.includes(con.email)) {
                contactIdsAlarm.push(con.id)
            }
        })

        const requestOptions = {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
                fkContactIds: contactIdsAlarm,
                fkLCLAlarmConfigId: tempAlarm.id
            })
        }

        CallPostAPI(CreateUrl(`/api/aquaguard/AlarmContacts`), requestOptions)
            .then(data => {
                createSuccessNotification()
                close()
            })
            .catch(err => {
                console.error(err)
                createErrorNotification()
                close()
            })


        
    }

    const handleGroupNameChange = (e:ChangeEvent<HTMLInputElement>):void => {
        const g: Group = { ...tempGroup }
        g.name = e.target.value
        setTempGroup(g)
    }


    const renderExternalUser = (data, intl: IntlShape):React.ReactNode => {
        return (
            <p>{data.data.isUser ? intl.formatMessage({ id: 'No' }) : intl.formatMessage({ id: 'Yes' })}</p>
        )
    }

    const resetNoContact = (alarmId: number | null):void => {
        handleSwitchToAlarmContacts(alarmId)
        setNoContacts(false)
    }

    return (
        <Modal
            show={show}
            style={{
                transform: 'translate(25vw,2vh)',
                zIndex: 10000000000

            }}
            className='modal-50w'
        >
            <Modal.Header>
                <Modal.Title>{`${intl.formatMessage({ id: 'Recipients for' })} ${tempAlarm?.type} ${intl.formatMessage({ id: 'alarm on channel' })} ${tempAlarm?.channel}`} 
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                {loading &&
                    <div style={{
                        display: 'flex',
                        justifyContent: 'center',
                        zIndex: 13000,
                        height: 300
                    }}>
                        <Loader color={undefined} />
                    </div>
                }
                {!loading && tempAlarm && !noContacts &&
                    <div>
                        <div style={{ display: 'flex', width: '100%', justifyContent: 'flex-end', marginBottom: 10 }}>
                            {tempAlarm?.contacts.length > 1 && <Button
                                variant="contained"
                                style={{ marginRight: 10 }}
                                color={addGroup ? 'error': "warning"}
                                onClick={():void => handleAddGroupClick() }
                            >
                                {addGroup ? intl.formatMessage({ id: 'Cancel Create Group' }) : intl.formatMessage({ id: 'Create New Recipient Group From Selected' })}
                            </Button>}
                            <Button
                                variant='contained'
                                color='secondary'
                                onClick={(): void => handleGroupModalClick()}
                                disabled={addGroup}
                            >
                                <FormattedMessage id="Load Recipient Group" />
                            </Button>
                        </div>
                        <DataGrid
                            dataSource={contactsForCompany}
                        >
                            <Column cellRender={(data):React.ReactNode => renderCheckBox(data)} width="50" caption="Select"/>
                            <Column dataField="fullname" caption={intl.formatMessage({ id: "Name" })} />
                            <Column dataField="isUser" caption={intl.formatMessage({ id: "External User"})} cellRender={(data): React.ReactNode => renderExternalUser(data, intl)} width={100} />
                            <Column dataField="email" caption={intl.formatMessage({id: 'Email'})} cellRender={(data): React.ReactNode => renderNotifications(data)} />
                        </DataGrid>
                        {addGroup && <div style={{
                            ...overViewStyle,
                            display: 'flex',
                            width: '100%',
                            justifyContent: 'space-between',
                            margin: '20px 0',
                            padding: '20px',
                            height: '100%',
                            borderLeft: "10px solid #00bf00"
                        }}>
                            <div
                                style={{ width: '100%' }}
                            >
                                <p><b><FormattedMessage id="Group Name" /> *</b></p>
                                <TextField
                                    fullWidth
                                    onChange={(e: ChangeEvent<HTMLInputElement>): void => handleGroupNameChange(e)}
                                    value={tempGroup?.name}
                                />
                            </div>
                        </div>}
                    </div>
                }
                {noContacts &&
                    <div style={{ display: 'flex', justifyContent: 'center' }} >
                        <div>
                            <h4><FormattedMessage id="No alarm contacts set for this company yet" /></h4>
                            <div style={{ display: 'flex', justifyContent: 'center' } }>
                                <Button variant="contained" onClick={(): void => resetNoContact(tempAlarm?.id)}><FormattedMessage id="Set Here" /></Button>
                            </div>
                        </div>
                    </div>
                }
            </Modal.Body>
            {!noContacts && <Modal.Footer>
                <Button
                    variant="contained"
                    style={{ marginRight: 10 }}
                    color="error"
                    onClick={(): void => close()}
                >
                    <FormattedMessage id="Cancel" />
                </Button>
                <Button
                    variant="contained"
                    color="primary"
                    onClick={(): void => saveRecipients()}
                >
                    {addGroup ? intl.formatMessage({ id: 'Save Recipients And Group' }) : intl.formatMessage({ id: 'Save Recipients' })}
                </Button>
            </Modal.Footer>}
            </Modal>
    )
}
export default RecipientsModal